module.exports = __webpack_public_path__ + "img/completed-quiz.2397d55e.svg";